// extracted by mini-css-extract-plugin
export default {"header":"header_yNYLT","headerButton":"headerButton_LX5Ql","headerTitle":"headerTitle_XoDg7","icon":"icon_tzxbA","title":"title_KRL1Z","container":"container_zQGFK"};